import React,{useState,useEffect} from 'react'
import {  ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import {AiOutlineEdit,AiOutlineDelete} from 'react-icons/ai'
import { DatePicker, Modal } from 'antd';
import moment from 'moment';
import { DeleteAllMetaService, DeleteMetaService, GetMetaService } from '../../../services/MetaService';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';

function MetaList() {


    const [data,setdata] = useState([])
    const [selecteddata,setselecteddata] = useState({})
    const [modal, setModal] = useState(false);
    const [page,setpage] = useState(1)
    
    const navigate = useNavigate()
    const [search, setsearch] = useState({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false })


    // console.log("data",data?.filter((f)=>f?.full_data !== undefined))

  
    useEffect(()=>{
        getMetaMessage(page,search?.from_date1,search?.to_date1,search?.text)
    },[page])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -40%)',
        width: 300,
        bgcolor: 'white',
        boxShadow: 4,
        p: 2,
        border:'0px solid white'
      };
    

  
  async function getMetaMessage(){
   const response = await GetMetaService(page,search?.from_date1,search?.to_date1,search?.text)
   setdata(response.data)
  }  

  async function deletemetaMessage(){
    const response = await DeleteMetaService(selecteddata._id)
    if(response.status === 200){
        setModal(false)
        toast.success("Data Deleted Successfully!")
        getMetaMessage()
    }
  }

  async function deleteAll() {
    const response = await DeleteAllMetaService()
    if(response.status === 200){
        toast.success("All Data Deleted Successfully!")
        getMetaMessage()
    }
  }

  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetMetaService(1, search?.from_date1, search?.to_date1,'')
    setdata(response?.data)
  }

  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
   
     <Modal
        keepMounted
        open={modal}
        onClose={()=>setModal(false)}
        width={300}
        footer={false}
        closable={false}
       
      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            {/* <div className='mr-1 w-full'> */}
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setModal(false)} />
            {/* </div> */}
            <div  className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Confirm'} onClick={()=>deletemetaMessage()}  /> 
            </div>
          </div>
        </div>
      </Modal>
        
      <div className='block sm:flex'>
        <SettingsMenu />

        <div className='md:w-[88%] px-4'>
        <div >
        <div className='pt-5'>
        <div className="flex justify-between align-center items-center border-b pb-2 ">
        <div className=' items-center justify-between'>
        <span className="font-[800] text-[14px]">Meta Message ({data?.pagination?.total})</span>

        <div className='flex md:hidden items-center text-[12px]'>
          <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
          <div>
            <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
          </div>
        </div>
        </div>


        <div className='flex flex-wrap items-center text-[12px]'>
          <div className='hidden md:flex items-center'>
          <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>
          <div>
            <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
          </div>
          </div>

          <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

          <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

          <div className='mr-2 mt-1 md:mt-0'>
            <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
          </div>

        <ButtonFilledAutoWidth onClick={deleteAll} btnName="Delete All" />
        </div> 
        </div>
        </div>


        {data?.datas?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data added based on your current page option please click on add the data button to see list here.</h6>
      </div>
       }

        {data?.datas?.length > 0 &&
        <div className='md:max-h-[85vh] md:overflow-hidden border-t border-l border-r mt-2'>
             {data?.datas?.length !== 0 &&
                   <>
                   {/* Desktop / tablet table */}
                   <div className='hidden md:block md:max-h-[85vh] md:overflow-auto'>
                   <div className='top-0 z-50 flex border-b w-full bg-white py-[-5px]  border-slate-200 relative'>
                      <h6 className='text-[12px] truncate min-w-0  w-[50px]  px-2 py-1 font-[400] border-r'>Sl No</h6>
                      <h6 className='text-[12px] truncate min-w-0 flex-1 px-2 py-1 font-[400] border-r capitalize'>All Info</h6>
                      <h6 className='text-[12px] truncate min-w-0  w-[120px]  px-2 py-1 font-[400] border-r capitalize'>Created On </h6>
                      <h6 className='text-[12px] truncate min-w-0  w-[50px]  px-1 py-1 font-[400] capitalize'>Action</h6>
                   </div>


                   {data?.datas?.map((d,i)=>(
                   <div key={d?._id} className='flex  w-full border-b cursor-pointer z-0'  >
                      <h6 className='text-[11px]  min-w-0 w-[50px] text-center  px-2 py-1   border-r '>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                      <h6 className='text-[11px] break-all  min-w-0 flex-1 px-2 py-1   border-r '>{JSON.stringify(d?.full_data)}</h6>
                      <h6 className='text-[10px]  min-w-0 w-[120px]  px-2 py-1 truncate  border-r '>{moment(d?.createdAt).format('ll')}</h6>
                      <h6  className='text-[12px] truncate min-w-0 w-[40px] flex mt-2 justify-center '>
                        <AiOutlineDelete size={12} className="ml-2 z-10 cursor-pointer" onClick={()=>{setselecteddata(d);setModal(true)}}/>
                      </h6>
                   </div>))}
                   </div>

                   {/* Mobile card list */}
                   <div className='md:hidden space-y-2'>
                     {data?.datas?.map((d,i)=>(
                       <div key={d?._id} className='border rounded-md p-3 bg-white'>
                         <div className='flex items-start justify-between'>
                           <h6 className='text-[10px] text-slate-400'>{moment(d?.createdAt).format('ll')}</h6>
                           <span className='p-2 -mr-2 -mt-2 cursor-pointer'><AiOutlineDelete size={16} onClick={()=>{setselecteddata(d);setModal(true)}}/></span>
                         </div>
                         <h6 className='text-[11px] break-all mt-1'>{JSON.stringify(d?.full_data)}</h6>
                       </div>
                     ))}
                   </div>
                   </>}
        </div>}
          </div>
        </div>
      </div> 
    </div>
  )
}

export default MetaList